import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  FaMedkit,
  FaSearch,
  FaSpinner,
} from "react-icons/fa";
import "./CategoryMedicines.css";
import df from '../../Assets/Brands/default.png'

const CategoryMedicines = () => {
  const { category } = useParams();
  const [medicines, setMedicines] = useState([]);
  const [filteredMedicines, setFilteredMedicines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Filter states
  const [priceRange, setPriceRange] = useState({ min: 0, max: 10000 });
  const [sortBy, setSortBy] = useState("default");
  const [brandFilter, setBrandFilter] = useState("all");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchMedicines = async () => {
      try {
        const response = await axios.get(
          `https://api.swasthmitra.com/api/medicine/category/${encodeURIComponent(
            category
          )}`
        );
        setMedicines(response.data);
        setFilteredMedicines(response.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch medicines. Please try again later.");
        setLoading(false);
      }
    };

    fetchMedicines();
  }, [category]);

  // Get unique brands for filter
  const uniqueBrands = [
    ...new Set(medicines.map((medicine) => medicine.brand)),
  ];

  // Apply filters
  useEffect(() => {
    let result = [...medicines];

    // Apply brand filter
    if (brandFilter !== "all") {
      result = result.filter((medicine) => medicine.brand === brandFilter);
    }

    // Apply price filter
    result = result.filter(
      (medicine) =>
        medicine.salePrice >= priceRange.min &&
        medicine.salePrice <= priceRange.max
    );

    // Apply sorting
    switch (sortBy) {
      case "price-low":
        result.sort((a, b) => a.salePrice - b.salePrice);
        break;
      case "price-high":
        result.sort((a, b) => b.salePrice - a.salePrice);
        break;
      case "name":
        result.sort((a, b) => a.name.localeCompare(b.name));
        break;
      default:
        break;
    }

    setFilteredMedicines(result);
  }, [medicines, brandFilter, priceRange, sortBy]);

  // Add Filter Component
  const FilterSection = () => (
    <div className="cm-filter-section">
      <div className="cm-filter-group">
        <label className="cm-filter-label">Brand:</label>
        <select
          className="cm-filter-select"
          value={brandFilter}
          onChange={(e) => setBrandFilter(e.target.value)}
        >
          <option value="all">All Brands</option>
          {uniqueBrands.map((brand) => (
            <option key={brand} value={brand}>
              {brand}
            </option>
          ))}
        </select>
      </div>

      {/* <div className="filter-group">
        <label>Price Range:</label>
        <div className="price-inputs">
          <input
            type="number"
            value={priceRange.min}
            onChange={(e) =>
              setPriceRange((prev) => ({
                ...prev,
                min: Number(e.target.value),
              }))
            }
            placeholder="Min"
          />
          <span>to</span>
          <input
            type="number"
            value={priceRange.max}
            onChange={(e) =>
              setPriceRange((prev) => ({
                ...prev,
                max: Number(e.target.value),
              }))
            }
            placeholder="Max"
          />
        </div>
      </div> */}

      {/* <div className="filter-group">
        <label>Sort By:</label>
        <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
          <option value="default">Default</option>
          <option value="price-low">Price: Low to High</option>
          <option value="price-high">Price: High to Low</option>
          <option value="name">Name</option>
        </select>
      </div> */}
    </div>
  );

  if (error) {
    return (
      <div className="cm-error-container">
        <FaMedkit />
        <p>{error}</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="cm-loading-container">
        <FaSpinner className="cm-loading-spinner" />
        <p className="cm-loading-text">Loading medicines...</p>
      </div>
    );
  }

  if (medicines.length === 0) {
    return (
      <div className="cm-empty">
        <FaSearch className="cm-empty-icon" />
        <h2 className="cm-empty-title">No Medicines Found</h2>
        <p className="cm-empty-subtitle">
          We couldn't find any medicines matching "{category}"
        </p>
      </div>
    );
  }

  return (
    <div className="cm-page">
      <div className="cm-header">
        <h1 className="cm-title">{category}</h1>
      </div>

      <FilterSection />

      <div className="cm-grid">
        {filteredMedicines.map((medicine) => (
          <div key={medicine._id} className="cm-card">
            <div className="cm-image-wrapper">
              <img
                src={medicine.imageUrl || medicine.imageUrls[0] || df}
                alt={medicine.name}
                className="cm-image"
              />
            </div>
            {medicine.dealRate < medicine.mrp && (
              <span className="cm-discount">
                {Math.round(
                  ((medicine.mrp - medicine.dealRate) / medicine.mrp) * 100
                )}
                % OFF
              </span>
            )}
            <button
              className="cm-primary-button"
              onClick={() => navigate(`/product/${medicine._id}`)}
            >
              View Details
              {/* <FaArrowRight className="icon" /> */}
            </button>
            <div className="cm-info">
              <h2 className="cm-product-name">
                {medicine.name.length > 20
                  ? `${medicine.name.slice(0, 40)}...`
                  : medicine.name}
              </h2>
              <div className="cm-tag-wrap">
                <p className="cm-tag">{medicine.brand}</p>
              </div>

              <div className="cm-price-info">
                <span className="cm-mrp">₹{medicine.mrp}</span>
                <span className="cm-deal-rate">
                  ₹{Math.round(medicine.dealRate)}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryMedicines;
